import { ShieldCheck } from "lucide-react";
import { ProCard } from "./StepPro";
import { PLATFORM_LABELS } from "@/lib/labels";

export const StepPlatforms = ({ form, update }) => (
  <div className="space-y-6">
    <div
      className="flex items-start gap-3 rounded-xl border border-amber-400/20 bg-amber-400/5 px-4 py-3"
      data-testid="platforms-confidential-notice"
    >
      <ShieldCheck size={18} className="text-amber-300 mt-0.5 shrink-0" />
      <p className="text-xs text-slate-300 leading-relaxed">
        <span className="font-semibold text-amber-300">Confidential.</span> These logins let Xyion manage your
        artist profiles, pitch music, and track streaming analytics on your behalf. Stored securely, visible only
        to Xyion HQ. Skip any platform you don't have access to.
      </p>
    </div>
    {Object.entries(PLATFORM_LABELS).map(([key, label]) => (
      <ProCard
        key={key}
        orgKey={key}
        label={label}
        values={form.platforms[key]}
        update={update}
        section="platforms"
      />
    ))}
  </div>
);
